export const TABS = {
  FILTERED: 'filtered',
  HISTORY: 'history',
  LIFETIME_COMING_SOON: 'lifetime_coming_soon',
};

export const HISTORY_MODE_FILTERS = [
  { value: 'ALL', label: 'All Modes' },
  { value: 'HP', label: 'Hardpoint' },
  { value: 'SND', label: 'Search & Destroy' },
  { value: 'CTL', label: 'Control' },
];

export const HISTORY_RANGE_FILTERS = [
  { value: 'ALL', label: 'View all' },
  { value: '5', label: 'Last 5' },
  { value: '10', label: 'Last 10' },
  { value: '20', label: 'Last 20' },
];

export const MODE_CONFIG = [
  { key: 'HP', label: 'Hardpoint' },
  { key: 'SND', label: 'Search & Destroy' },
  { key: 'CTL', label: 'Control' },
];

